import styled from 'styled-components';
import { AppHeader } from '@mindly/ui-components';

export const AppHeaderStyled = styled(AppHeader)`
  & ion-progress-bar {
    &::part(track) {
      background: #e8ecf2;
    }

    &::part(progress) {
      background: #177590;
    }
  }
`;

export const BackButton = styled.button`
  border: none;
  outline: none;
  background: transparent;
  color: #1d201f;
  font-size: 20px;
`;
